export { TextViewDialogComponent, TextViewDialogData } from './text-view-dialog.component';
